import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    padding-top: 5.2em;
    padding-bottom: 5.2em;
    background-color: #F3F3F3;

    .boxs-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;
        z-index: 2;

        .box-wrapper {
            background-color: #000;
            padding: 2.2em 3em;
            margin: .5em;
            width: 45%;
            height: 21em;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            .content {
                text-align: center;

                .title {
                    font-size: 2em;
                    color: #fff;
                    margin-bottom: 1.2em;
                    min-height: 3em;
                }
                .subtitle {
                    font-size: 1.05em;
                    color: #fff;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletL}) {
        font-size: 85%;
    }

    @media all and (max-width: ${vars.tabletS}) {
        .boxs-wrapper {
            flex-direction: column;

            .box-wrapper {
                width: 90%;
                .content {
                    .title {
                        min-height:unset;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${vars.mobileM}) {
        .boxs-wrapper {
            .box-wrapper {
                width: 90%;
                padding: 3em 2.6em;

                .content {
                    .title {
                        font-size: 1.6em;
                        margin-bottom: 1em;
                    }

                    .subtitle {
                        font-size: 1.1em;
                    }
                }

                .layout-button {
                    font-size: 1.2em;
                }
            }
        }
    }
`;